import { createContext, useContext } from "react";

export interface QuietDiagnostics {
  /** True while only ERROR diagnostics should reach any surface. */
  readonly quiet: boolean;
  readonly setQuiet: (on: boolean) => void;
}

export const QuietDiagnosticsContext = createContext<QuietDiagnostics | null>(null);

/** The quiet flag + setter. Throws outside a provider (viewer always wraps). */
export function useQuietDiagnostics(): QuietDiagnostics {
  const q = useContext(QuietDiagnosticsContext);
  if (!q) throw new Error("useQuietDiagnostics must be used within a <QuietDiagnosticsProvider>");
  return q;
}

/** Read-only, optional — for surfaces that may mount without the provider
 *  (e.g. the Studio host): absent → never quiet. */
export function useOptionalQuietDiagnostics(): boolean {
  return useContext(QuietDiagnosticsContext)?.quiet ?? false;
}
